var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYTfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "formkit:youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.016 2.89844C2.55152 2.89844 2.35156 3.89752 2.35156 11.7612C2.35156 19.625 2.55152 20.624 14.016 20.624C25.4805 20.624 25.6805 19.625 25.6805 11.7612C25.6805 3.89752 25.4805 2.89844 14.016 2.89844ZM17.7487 12.148L12.5163 14.5651C12.0497 14.7746 11.6831 14.5329 11.6831 14.0333V9.48914C11.6831 8.9896 12.0664 8.74789 12.5163 8.95737L17.7487 11.3745C18.2152 11.584 18.2152 11.9385 17.7487 12.148Z",
    fill: "#344054"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYTfill);
export default __webpack_public_path__ + "static/media/YTfill.0e5291aa4168c417461549d4e7eb5074.svg";
export { ForwardRef as ReactComponent };